import {
  APPLICATION_TYPE_FORM,
  APPLICATION_TYPE_REDIRECT
} from '@/jobapplication/constants'

// Internal tracking events - used both for job and company tracking
export const INTERNAL_EVENT_QUALIFIED_VIEW = 'qualified_view'
export const INTERNAL_EVENT_USER_INTERACTION = 'user_interaction'

// Internal tracking job events
export const INTERNAL_JOB_EVENT_VIEW = 'view'
export const INTERNAL_JOB_EVENT_APP_ACTION_EXTERN = 'application_action_extern'
// used for GTM user interaction category as well
export const INTERNAL_JOB_EVENT_APP_POTENTIAL_EMAIL = 'application_potential_email'
// used for GTM user interaction category as well
export const INTERNAL_JOB_EVENT_APP_POTENTIAL_REDIRECT = 'application_potential_redirect'
export const INTERNAL_JOB_EVENT_APP_VIEW = 'application_view'
export const INTERNAL_JOB_EVENT_SLIDESHOW = 'slideshow'
// unused begin
export const INTERNAL_JOB_EVENT_CLICK_INDEED = 'click_indeed'
export const INTERNAL_JOB_EVENT_WEBSITE = 'website'
export const INTERNAL_JOB_EVENT_APP_ACTION = 'application_action'
export const INTERNAL_JOB_EVENT_APP_EXPRESS_ACTION = 'express_application_action'
// unused end

// Internal tracking company events
export const INTERNAL_COMPANY_EVENT_VIEW = 'view'
export const INTERNAL_COMPANY_EVENT_WEBSITE = 'website'
export const INTERNAL_COMPANY_EVENT_APP_VIEW_INTERN = 'application_view_intern'
export const INTERNAL_COMPANY_EVENT_APP_VIEW_EXTERN = 'application_view_extern'
export const INTERNAL_COMPANY_EVENT_APP_ACTION_EXTERN = 'application_action_extern'

// Microconversion events
export const MICROCONVERSION_EVENT_COPY_TO_CLIPBOARD_JOB = 'copy_to_clipboard_job'
export const MICROCONVERSION_EVENT_COPY_TO_CLIPBOARD_COMPANY = 'copy_to_clipboard_company'
export const MICROCONVERSION_EVENT_PRINT_JOB = 'print_job'
export const MICROCONVERSION_EVENT_PRINT_COMPANY = 'print_company'
export const MICROCONVERSION_EVENT_SHARE_JOB = 'share_job'
export const MICROCONVERSION_EVENT_SHARE_JOB_APPLICATION_REDIRECT_OVERLAY = 'share_job_application_redirect_ovl'
export const MICROCONVERSION_EVENT_SHARE_COMPANY = 'share_company'
export const MICROCONVERSION_EVENT_SWITCH_NEXT_JOB = 'switch_next_job'
export const MICROCONVERSION_EVENT_SWITCH_NEXT_COMPANY = 'switch_next_company'
export const MICROCONVERSION_EVENT_CLICK_COMPANY_WEBSITE = 'click_external_company_website'
export const MICROCONVERSION_EVENT_CLICK_KUNUNU = 'view_kununu_rating_company'
export const MICROCONVERSION_EVENT_CLICK_SHARE_ARTICLE = 'share_article'

// GTM events
export const GTM_EVENT_USER_INTERACTION = 'user_interaction'
export const GTM_EVENT_PAGE_VIEW = 'page_view'
export const GTM_EVENT_INITIAL_SEARCH = 'initial_search'
export const GTM_EVENT_MANUAL_SEARCH = 'manual_search'
export const GTM_EVENT_RATING_WIDGET = 'jbc_widget'
export const GTM_EVENT_USE_GEOLOCATION = 'use_geolocation'
export const GTM_EVENT_QUALIFIED_JOB_VIEW_10_50 = 'qualified_jobview_10_50'
export const GTM_EVENT_QUALIFIED_JOB_VIEW_10_60 = 'qualified_jobview_10_60'
export const GTM_EVENT_QUALIFIED_JOB_VIEW_10_70 = 'qualified_jobview_10_70'
export const GTM_EVENT_QUALIFIED_JOB_VIEW_10_80 = 'qualified_jobview_10_80'

// Categories for user interaction event in gtm
export const GTM_EVENT_USER_INTERACTION_CATEGORY_MICROCONVERSION = 'Microconversion'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_APPLICATION_EXPRESS = 'application_action_express'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_APPLICATION = 'application_action'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_APPLICATION_BACKFILL = 'application_action_backfill'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_APPLICATION_EXTERNAL = 'application_action_extern'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_APPLICATION_BACKFILL_LAYER = 'application_action_backfill_with_layer'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_APPLY_FORM = 'apply_button_form'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_APPLY_FORM_UNSOLICITED = 'apply_button_form_unsolicited'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_APPLY_REDIRECT_UNSOLICITED = 'apply_button_redirect_unsolicited'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_APPLY_REDIRECT = 'apply_button_redirect'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_SCROLL_JOB = 'scroll_job'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_JOBMAIL = 'jobmail'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_SHOW_APPLY_FILE_ATTACHMENTS = 'show_apply_file_attachments'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_REUSE_APPLY_FILE_ATTACHMENTS = 'reuse_apply_file_attachments'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_PAGINATION_BUTTON = 'Weitere Ergebnisse anzeigen'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_AUTO_LOAD_NEXT_PAGE = 'scroll_search'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_FORMS = 'forms'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_RATING = 'Rating'
export const GTM_EVENT_USER_INTERACTION_CATEGORY_JOBVIEW = 'job_views'

// Actions for user interaction event in gtm
export const GTM_EVENT_USER_INTERACTION_ACTION_CLICK = 'Klicks'
export const GTM_EVENT_USER_INTERACTION_ACTION_SCROLL = 'scroll'
export const GTM_EVENT_USER_INTERACTION_ACTION_VIEWS = 'Views'
export const GTM_EVENT_USER_INTERACTION_ACTION_NO_ATTACHMENTS = 'no_attachments'
export const GTM_EVENT_USER_INTERACTION_ACTION_NEW_ATTACHMENTS = 'new_attachments'
export const GTM_EVENT_USER_INTERACTION_ACTION_PREVIOUS_ATTACHMENTS = 'previous_attachments'
export const GTM_EVENT_USER_INTERACTION_ACTION_REUSE_ATTACHMENTS_TICKED = 'reuse_attachments_ticked'
export const GTM_EVENT_USER_INTERACTION_ACTION_SUBMIT_BUTTON_CLICKED = 'submit_button_clicked'
export const GTM_EVENT_USER_INTERACTION_ACTION_JOBVIEW = 'job_view'
export const GTM_EVENT_USER_INTERACTION_ACTION_QUALIFIED_JOBVIEW = 'job_view_qualified'

// Labels for user interaction event in gtm
export const GTM_EVENT_USER_INTERACTION_LABEL_APPLICATION = 'application'
export const GTM_EVENT_USER_INTERACTION_LABEL_APPLICATION_UNSOLICITED = 'application_unsolicited'
export const GTM_EVENT_USER_INTERACTION_LABEL_RECRUITING = 'recruiting'
export const GTM_EVENT_USER_INTERACTION_LABEL_JOBMAIL_POPUP = 'jobmail_popup'
export const GTM_EVENT_USER_INTERACTION_LABEL_JOBMAIL_POPUP_SENT = 'jobmail_popup_sent'
export const GTM_EVENT_USER_INTERACTION_LABEL_JOBMAIL_FORM_SLIDE = 'jobmail_form_slide'
export const GTM_EVENT_USER_INTERACTION_LABEL_JOBMAIL_FORM_SLIDE_SENT = 'jobmail_form_slide_sent'
export const GTM_EVENT_USER_INTERACTION_LABEL_JOBMAIL_POPUP_ACTIVATION_RESEND = 'jobmail_form_resent_popup'
export const GTM_EVENT_USER_INTERACTION_LABEL_JOBMAIL_SLIDE_ACTIVATION_RESEND = 'jobmail_form_resent_slide'
export const GTM_EVENT_USER_INTERACTION_LABEL_JOBMAIL_POPUP_BACKFILL = 'jobmail_popup_backfill'
export const GTM_EVENT_USER_INTERACTION_LABEL_JOBMAIL_POPUP_SENT_BACKFILL = 'jobmail_popup_sent_backfill'
export const GTM_EVENT_USER_INTERACTION_LABEL_JOBMAIL_UNSUBSCRIBE_CONFIRMED = 'jobmail_unsubscribe_confirmed'
export const GTM_EVENT_USER_INTERACTION_LABEL_NEWSLETTER_SLIDE = 'newsletter_form_slide'
export const GTM_EVENT_USER_INTERACTION_LABEL_SLIDESHOW_ARROW = 'slideshow_arrow'
export const GTM_EVENT_USER_INTERACTION_LABEL_JOB_SEARCH = 'job_search'

export const GTM_EVENT_JOB_FOR_APPLICATION = 'job_for_application'

export const applicationTypeToGtmUserInteractionCategory = {
  [APPLICATION_TYPE_FORM]: GTM_EVENT_USER_INTERACTION_CATEGORY_APPLY_FORM,
  [APPLICATION_TYPE_REDIRECT]: GTM_EVENT_USER_INTERACTION_CATEGORY_APPLY_REDIRECT
}

export const searchTypeToInternalViewEvent = {
  job: INTERNAL_JOB_EVENT_VIEW,
  company: INTERNAL_COMPANY_EVENT_VIEW
}

export const searchTypeToMicroconversionCopyToCliboard = {
  job: MICROCONVERSION_EVENT_COPY_TO_CLIPBOARD_JOB,
  company: MICROCONVERSION_EVENT_COPY_TO_CLIPBOARD_COMPANY
}

export const searchTypeToMicroconversionNavigateNext = {
  job: MICROCONVERSION_EVENT_SWITCH_NEXT_JOB,
  company: MICROCONVERSION_EVENT_SWITCH_NEXT_COMPANY
}
